import { useQuery } from "@tanstack/react-query";
import type { EntityMeta } from "@wms/domain";
import { Tag } from "antd";
import { useParams, useSearchParams } from "react-router-dom";
import { api } from "../api/client";
import { EntityTable } from "../components/EntityTable";
import { LoadProblem } from "../components/LoadProblem";
import { PageHeader } from "../components/PageHeader";
import { MyTasksPage } from "./MyTasksPage";

export function EntityListPage() {
  const { entity = "" } = useParams();
  const [searchParams] = useSearchParams();
  if (entity === "tasks" && searchParams.get("mine")) return <MyTasksPage />;
  return <EntityList entity={entity} />;
}

function EntityList({ entity }: { entity: string }) {
  const meta = useQuery({ queryKey: ["meta", entity], queryFn: () => api.get<EntityMeta>(`/${entity}/meta`) });
  if (meta.isError) return <LoadProblem error={meta.error} />;
  return (
    <div>
      <PageHeader
        title={meta.data?.label_plural ?? ""}
        subtitle={meta.data?.section_label}
        tags={meta.data?.readonly ? <Tag bordered={false}>только просмотр</Tag> : undefined}
      />
      <div className="wms-card" style={{ padding: 16 }}>
        <EntityTable key={entity} entity={entity} />
      </div>
    </div>
  );
}
